export const DEMAND_POPUP_TICK = 1000;
export const DEMAND_POPUP_TIME = 6 * 60 * DEMAND_POPUP_TICK;
